import { APIClient } from '../api_helper';
import * as url from './url_helper';
import qs from 'qs';

const config = require('../../config');
const WATER_RIGHTS_BASE = config.api.REACT_APP_SPED_WATER_RIGHTS_API_URL;

const apiClient = new APIClient();

// Helper function to stringify query parameters
const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

// Get Installation Location List with Query (for remote operations)
export const getInstallationLocationListQuery = params => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_INSTALLATION_LOCATIONS}?${stringifyParams(
			params
		)}`
	);
};

// Get Installation Location List with Query
export const getInstallationLocationList = params => {
	const queryParams = {
		filters: {
			disable: {
				$eq: false,
			},
		},
        // populate: ['creation_user', 'modification_user'],
		pagination: {
			page: 1,
			pageSize: 1000,
		},
		sort: ['name:asc'],
		...params,
	};

	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_INSTALLATION_LOCATIONS}?${stringifyParams(
			queryParams
		)}`
	);
};

// Get Single Installation Location
export const getInstallationLocation = installation_location_id => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_INSTALLATION_LOCATION}${installation_location_id}`
	);
};

// Add New Installation Location
export const addNewInstallationLocationApi = installation_location => {
	return apiClient.create(
		`${WATER_RIGHTS_BASE}${url.POST_INSTALLATION_LOCATION}`,
		installation_location
	);
};

// Update Installation Location
export const updateInstallationLocationApi = installation_location => {
	return apiClient.put(
		`${WATER_RIGHTS_BASE}${url.PUT_INSTALLATION_LOCATION}${installation_location._id}`,
		installation_location
	);
};

// Delete Installation Location
export const deleteInstallationLocationApi = installation_location_id => {
	return apiClient.delete(
		`${WATER_RIGHTS_BASE}${url.DELETE_INSTALLATION_LOCATION}${installation_location_id}`
	);
};

// Check if Installation Location Exists
export const checkInstallationLocationExistsApi = name => {
	const queryParams = {
		filters: {
			name: {
				$eq: name,
			},
		},
		fields: ['_id'],
		pagination: {
			page: 1,
			pageSize: 1,
		},
	};

	return apiClient
		.get(
			`${WATER_RIGHTS_BASE}${
				url.CHECK_INSTALLATION_LOCATION_EXISTS
			}?${stringifyParams(queryParams)}`
		)
		.then(response => {
			return { exists: response && response.length > 0 };
		})
		.catch(() => {
			return { exists: false };
		});
};
